import { render, staticRenderFns } from "./TooltipContent.vue?vue&type=template&id=71f2f124&scoped=true"
import script from "./TooltipContent.vue?vue&type=script&lang=js"
export * from "./TooltipContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f2f124",
  null
  
)

export default component.exports